import { render } from "./ServicingSummary.vue?vue&type=template&id=3a6b4ebc"
import script from "./ServicingSummary.vue?vue&type=script&lang=js"
export * from "./ServicingSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__